// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"e2dcd530","488":"65a6a8ec"}[chunkId] + ".chunk.js";
};